import { QueryClient } from "@tanstack/react-query";

// Stale-while-revalidate defaults: cached data renders instantly on
// revisit, then a background refetch silently swaps in fresh data if it
// changed — no manual reload needed to see a change made "from the other
// side" (e.g. an admin action). staleTime is short enough that changes
// show up quickly, long enough to avoid re-fetching on quick back-and-forth
// navigation between pages.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 1,
    },
  },
});
